<template>
  <div class="details">
    <!-- <div class="orderDetailsT">
      <img src="static/images/left2.png"  alt class="orderDetailsTReturn" @click="back" />
      <p>数据看板</p>
    </div> -->
    <div class="record">
      <div class="recordCon">
        <div class="record1">
          <p class="recordTit" @click="isShow(0)">
            销售额数据
            <img :src="show[0] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record1C" v-show="!!show[0]">
            <div class="record1CT">
              <div class="record1CTE">
                <h4>今日销售总额</h4>
                <p><em>￥</em>{{sales.samedayAmounts}}</p>
              </div>
              <div class="record1CTE">
                <h4>当月销售总额</h4>
                <p><em>￥</em>{{sales.sameMonthMemberTotal}}</p>
              </div>
              <div class="record1CTE">
                <h4>累计总销售额</h4>
                <p><em>￥</em>{{sales.amounts}}</p>
              </div>
            </div>
            <div class="record1CB">
              <div class="record1CBE">
                <p>日环比 : {{sales.dayGrowthRate}}</p>
                <p>月环比 : {{sales.monthGrowthRate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="record1">
          <p class="recordTit" @click="isShow(1)">
            会员数据
            <img :src="show[1] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record1C record1C1" v-show="!!show[1]">
            <div class="record1CT">
              <div class="record1CTE">
                <h4>当日新增会员</h4>
                <p>{{memberinfo.samedayMemberTotal}}<em>位</em></p>
              </div>
              <div class="record1CTE">
                <h4>当月新增会员</h4>
                <p>{{memberinfo.sameMonthMemberTotal}}<em>位</em></p>
              </div>
              <div class="record1CTE">
                <h4>总会员</h4>
                <p>{{memberinfo.memberTotal}}<em>位</em></p>
              </div>
            </div>
            <div class="record1CB">
              <div class="record1CBE">
                <p>日环比 : {{memberinfo.dayGrowthRate}}</p>
                <p>月环比 : {{memberinfo.monthGrowthRate}}</p>
              </div>
              <p class="record1CBP">
                <span>会员总余额</span>
                <em>￥</em>{{memberinfo.amountTotals}}
              </p>
            </div>
          </div>
        </div>
        <div class="record2">
          <p class="recordTit" @click="isShow(2)">
            当前在售产品种类
            <img :src="show[2] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record2C" v-show="!!show[2]">
            <div class="record2CT">
              <p>产品名称</p>
              <p>库存数量</p>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <ul class="record2CS">
                <li v-for="(item, index) in onsalelist" :key="index">
                  <div class="record2CSL">
                    <p>{{item.id}}</p>{{item.productName}}
                  </div>
                  <p class="record2CSR">{{item.totalInventoryCurrent}}{{item.unit}}</p>
                </li>
              </ul>
            </van-list>
          </div>
        </div>
        <div class="record2">
          <p class="recordTit" @click="isShow(3)">
            库存告急产品
            <img :src="show[3] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record2C" v-show="!!show[3]">
            <div class="record2CT">
              <p>产品名称</p>
              <p>库存数量</p>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <ul class="record2CS">
                <li v-for="(item, index) in alarmlist" :key="index">
                  <div class="record2CSL">
                    <p>{{item.id}}</p>{{item.productName}}
                  </div>
                  <p class="record2CSR">{{item.totalInventoryCurrent}}{{item.unit}}</p>
                </li>
              </ul>
            </van-list>
          </div>
        </div>
      </div>

      <!-- <div class="record4">
        <div class="record4Con">
        <dl class="record4S">
          <dt v-for="(item, index) in 10" :key="index">
            <p class="recordTit">
              茶艺师销售排名（日）
              <img src="static/images/down.png"  alt/>
            </p>
            <div class="record3C">
              <div class="record3CT">
                <p>茶艺师名称</p>
                <p>销售总额</p>
              </div>
              <ul class="record3CS">
                <li v-for="(item, index) in 10" :key="index">
                  <div class="record3CSL">
                    <p>
                      <img src="static/images/num1.png"  alt v-if="index==0"/>
                      <img src="static/images/num2.png"  alt v-else-if="index==1"/>
                      <img src="static/images/num3.png"  alt v-else-if="index==2"/>
                      <em v-else>{{index+1}}</em>
                    </p>
                    赵艺南
                  </div>
                  <p class="record3CSR">￥12345</p>
                </li>
              </ul>
            </div>
          </dt>
        </dl>
        </div>
      </div> -->

      <div class="recordCon">
        <div class="record3 record31">
          <p class="recordTit" @click="isShow(4)">
            茶艺师销售排名（日）
            <img :src="show[4] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record3C" v-show="!!show[4]">
            <div class="record3CT">
              <p>产品名称</p>
              <p>销售总额</p>
            </div>
            <ul class="record3CS">
              <li v-for="(item, index) in teaerlist" :key="index">
                <div class="record3CSL">
                  <p>
                    <img src="static/images/num1.png"  alt v-if="index==0"/>
                    <img src="static/images/num2.png"  alt v-else-if="index==1"/>
                    <img src="static/images/num3.png"  alt v-else-if="index==2"/>
                    <em v-else>{{index+1}}</em>
                  </p>
                  {{item.itemName}}
                </div>
                <p class="record3CSR">￥{{item.totalAmounts}}</p>
              </li>
            </ul>
          </div>
        </div>

        <div class="record3 record31" >
          <p class="recordTit" @click="isShow(5)">
            当月最佳销售单品排名
            <img :src="show[5] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record3C" v-show="!!show[5]">
            <div class="record3CT">
              <p>产品名称</p>
              <p>销售总额</p>
            </div>
            <ul class="record3CS">
              <li v-for="(item, index) in productlist" :key="index">
                <div class="record3CSL">
                  <p>
                    <img src="static/images/num1.png"  alt v-if="index==0"/>
                    <img src="static/images/num2.png"  alt v-else-if="index==1"/>
                    <img src="static/images/num3.png"  alt v-else-if="index==2"/>
                    <em v-else>{{index+1}}</em>
                  </p>
                  {{item.itemName}}
                </div>
                <p class="record3CSR">￥{{item.totalAmounts}}</p>
              </li>
            </ul>
          </div>
        </div>

        <div class="record3">
          <p class="recordTit" @click="isShow(6)">
            当月最具价值会员排名
            <img :src="show[6] ? 'static/images/down.png' : 'static/images/up.png'"  alt/>
          </p>
          <div class="record3C" v-show="!!show[6]">
            <div class="record3CT">
              <p>会员名称</p>
              <p>销售总额</p>
            </div>
            <ul class="record3CS">
              <li v-for="(item, index) in memberlist" :key="index">
                <div class="record3CSL">
                  <p>
                    <img src="static/images/num1.png"  alt v-if="index==0"/>
                    <img src="static/images/num2.png"  alt v-else-if="index==1"/>
                    <img src="static/images/num3.png"  alt v-else-if="index==2"/>
                    <em v-else>{{index+1}}</em>
                  </p>
                  {{item.itemName}}
                </div>
                <p class="record3CSR">￥{{item.totalAmounts}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    
  </div>
</template>

<script>
import {salesVolume, member, onSale, alarmList, teaer, singleProduct, memberTotal} from "../api/api"
export default {
  name: 'record',
  data () {
    return {
      show: [true, true, true, true, true, true, true],
      isDetails:0,
      sales: {},
      memberinfo: {},
      onsalelist: [],
      alarmlist: [],
      teaerlist: [],
      productlist: [],
      memberlist: [],
      loading: false,
      finished: false,
      params: {
        current: 1,
        size: 10
      }
    }
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
    this.allData()
    this.salelist()
    this.alarmList()
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    // 返回上一页
    back() {
      this.$router.go(-1)
    },
    // 加载更多
    onLoad() {
      this.params.current ++
      this.salelist()
      this.alarmList()
    },
    allData() {
      // 销售额数据
      salesVolume(this, {}).then(res => {
        if(res.code == 200) {
          this.sales = res.data
        }
      })

      //会员数据
      memberTotal(this, {}).then(res => {
        if(res.code == 200) {
          this.memberinfo = res.data
        }
      })

      // 茶艺师销售额排名
      teaer(this, {}).then(res => {
        if(res.code == 200) {
          this.teaerlist = res.data
        }
      })

      // 当月最佳销售单品排名
      singleProduct(this, {}).then(res => {
        if(res.code == 200) {
          this.productlist = res.data
        }
      })

      // 当月最具价值会员排名
       member(this, {}).then(res => {
        if(res.code == 200) {
          this.memberlist = res.data
        }
      })
    },
    // 当前在售产品
    salelist() {
      onSale(this, this.params).then(res => {
        if(res.code == 200) {
          const list = res.data.records
          if(list == null || list.length === 0) {
            this.finished = true
            return
          }
          if (list.length < res.data.size) {
            this.finished = true
          }
          if (res.data.pages === 1) {
            this.onsalelist = list
          } else {
            this.onsalelist = this.onsalelist.concat(list)
          }
        }
      })
    },
    // 库存告急产品
    alarmList() {
      alarmList(this, this.params).then(res => {
        if(res.code == 200) {
          const list = res.data.records
          if(list == null || list.length === 0) {
            this.finished = true
            return
          }
          if (list.length < res.data.size) {
            this.finished = true
          }
          if (res.data.pages === 1) {
            this.alarmlist = list
          } else {
            this.alarmlist = this.onsalelist.concat(list)
          }
        }
      })
    },

    // 显示/隐藏
    isShow(index) {
      this.show.splice(index, 1, !this.show[index])
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
  
</style>



// WEBPACK FOOTER //
// src/components/record.vue